module.exports = __webpack_public_path__ + "img/right_building.a98593b5.png";